import { useBoardSections } from 'src/hooks/api/useBoardSections';

export const useIsCurrentViewInboxType = () => {
  const sections = useBoardSections();

  return (viewId: string) => sections.inbox.some(view => view.id === viewId);
};
